import React, {useContext} from 'react';
import {TouchableOpacity, View} from "react-native";
import TextM from "@common/components/text/TextM";
import {theme} from "@common/theme/theme";
import {DimensionsContext} from "@common/utils/mobileUtils";

const FeelingQuizItem = (props) => {
    const {
        question,
        onSelectAnswer,
        type,
        selectedIndexes,
        numberOfItems = 8,
        answers = [],
        descriptions = [],
        labels
    } = props;

    const dimensions = useContext(DimensionsContext);

    const renderAnswers = () => {
        const items = answers.length ? answers : Array.from({length: numberOfItems - 1}, (_, i) => (i + 1));
        return items.map((answer, index) => {
            const isSelected = selectedIndexes[type] === answer;

            return (
                <View key={index + 1} style={{flex: 1}}>
                    <TouchableOpacity
                        style={{
                            borderRightWidth: 1,
                            borderTopWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: index === 0 || isSelected ? 1 : 0,
                            borderColor: isSelected ? theme.colors.primary : theme.colors.lightMore,
                            paddingVertical: 20,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: isSelected ? theme.colors.primaryLighter : theme.colors.white,
                        }}
                        onPress={() => onSelectAnswer(answer, type)}
                    >
                        <TextM
                            wrap
                            color={theme.colors.primary}
                            fontSize={answers.length ? 14 : 18}
                            fontWeight={isSelected ? "Bold" : "Regular"}
                        >
                            {answer}
                        </TextM>
                    </TouchableOpacity>
                    <TextM
                        wrap
                        color={theme.colors.primary}
                        fontSize={12}
                        fontWeight={"Bold"}
                        style={{textAlign: "center"}}
                    >
                        {isSelected ? labels[index] : " "}
                    </TextM>
                </View>
            );
        });
    };

    const renderDescription = () => {
        const selectedIndex = selectedIndexes[type];
        if (selectedIndex && descriptions[selectedIndex - 1]) {
            return (
                <View style={{}}
                >
                    <TextM
                        wrap
                        color={theme.colors.primary}
                        fontSize={14}
                        fontWeight={"SemiBold"}
                        style={{marginTop: 10}}
                    >
                        {labels[selectedIndex - 1]}
                    </TextM>
                    <TextM
                        wrap
                        color={theme.colors.primary}
                        fontSize={14}
                        fontWeight={"Regular"}
                        style={{marginTop: 2}}
                    >
                        {descriptions[selectedIndex - 1]}
                    </TextM>
                </View>
            );
        }
        return null;
    };

    return (
        <View
            style={{
                marginBottom: 25,
                alignItems: 'flex-start',
                width: '100%',
            }}
        >
            <TextM wrap color={theme.colors.primary} fontSize={16} fontWeight={"SemiBold"}>
                {question}
            </TextM>
            <View
                style={{
                    flexDirection: 'row',
                    width: '100%',
                    marginTop: 5,
                }}
            >
                {renderAnswers()}
            </View>
            {renderDescription()}
        </View>
    );
};

export default FeelingQuizItem;
